<template>
  <div
    class="offer-card"
    :class="componentClasses"
  >
    <div class="offer-card__row">
      <div class="offer-card__left">
        <div class="offer-card__title">
          {{ title }}
        </div>
        <div class="offer-card__desc">
          {{ offerSubText }}
        </div>
      </div>
      <div
        v-if="dayPriceFull > dayPrice"
        class="offer-card__old-price"
      >
        {{ dayPriceFull }}&nbsp;₽
      </div>
      <div class="offer-card__right">
        <div class="offer-card__price">
          {{ dayPrice }}&nbsp;₽
        </div>
        <div class="offer-card__period">
          в день
        </div>
      </div>
    </div>
    <div class="offer-card__labels">
      <div
        v-if="discount"
        class="offer-card__label"
      >
        <sprite
          src="sprites_discount"
          class="offer-card__discount"
        />
        {{ discount }}
      </div>
      <div
        v-if="cashback"
        class="offer-card__label offer-card__label--cashback"
      >
        <sprite
          src="sprites_discount"
          class="offer-card__discount"
        />
        {{ cashback }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfferCard',

  props: {
    title: {
      type: String,
      required: true,
    },

    offerSubText: {
      type: String,
      required: true,
    },

    dayPriceFull: {
      type: Number,
      required: true,
    },

    dayPrice: {
      type: Number,
      required: true,
    },

    discount: {
      type: String,
      default: '',
    },

    cashback: {
      type: String,
      default: '',
    },

    isActive: {
      type: Boolean,
      default: false,
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    componentClasses () {
      return {
        'offer-card--active': this.isActive,
        'offer-card--disabled': this.isDisabled,
      }
    },
  },
}
</script>

<style lang="scss">
.offer-card {
  $self: &;
  border-radius: 16px;
  background:  map-get($colors, 'grey_6');
  color: map-get($colors, 'black');
  padding: 0.16rem 0.2rem;
  transition: all .2s;
  cursor: pointer;

  &__title {
    font-weight: 700;
    font-size: 0.2rem;
    line-height: 0.24rem;
  }

  &__desc {
    font-weight: 600;
    font-size: 0.12rem;
    line-height: 0.16rem;
    color: map-get($colors, 'grey_60');
    transition: color .2s;
  }

  &__price {
    font-weight: 700;
    font-size: 0.16rem;
    line-height: 0.24rem;
    letter-spacing: -0.32px;
    text-align: right;
  }

  &__period {
    font-weight: 700;
    font-size: 0.12rem;
    line-height: 0.16rem;
    letter-spacing: 0.6px;
    text-align: right;
  }

  &__row {
    display: flex;
  }

  &__left {
    flex-grow: 1;
  }

  &__old-price {
    margin-right: 7px;
    color: map-get($colors, 'grey_40');
    font-size: 0.14rem;
    font-weight: 600;
    line-height: 0.20rem;
    letter-spacing: -0.15px;
    margin-top: 0.02rem;
    text-decoration: line-through;
  }

  &__discount {
    width: 0.12rem;
    height: 0.12rem;
  }

  &__labels {
    display: flex;
    gap: 0.1rem;
  }

  &__label {
    display: flex;
    align-items: center;
    gap: 0.04rem;
    width: fit-content;
    padding: 0.04rem 0.08rem 0.04rem 0.04rem;
    margin-top: 0.12rem;
    margin-left: -0.04rem;
    border-radius: 0.16rem;
    background: map-get($colors, 'white');
    color: map-get($colors, 'red_error');
    font-weight: 600;
    font-size: 0.1rem;
    line-height: 0.12rem;
    letter-spacing: 0.1px;
    text-align: center;
    transition: color .2s, background .2s;

    &--cashback {
      color: map-get($colors, 'cornflower_blue');
    }
  }

  &--active {
    background: map-get($colors, 'parsley');
    color: map-get($colors, 'white');

    #{$self}__desc {
      color: map-get($colors, 'las-palmas');
    }

    #{$self}__label {
      background: map-get($colors, 'sunset_orange');
      color: map-get($colors, 'white');

      &--cashback {
        background: linear-gradient(#638FFF, #8962F8);
      }
    }

    #{$self}__old-price {
      color: map-get($colors, 'white');
      opacity: 0.5;
    }
  }

  &:active {
    transform: scale(0.98);
  }

  &--disabled {
    #{$self}__label {
      color: map-get($colors, 'black');
    }
  }
}
</style>
